import React from 'react';
import './Hero.css';
import BackgroundVideo from './BackgroundVideo';
import AnimatedText from './AnimatedText';

const Hero = () => {
  return (
    <section className="hero">
      <div className="hero-background">
        <BackgroundVideo />
        <div className="vignette-overlay"></div>
      </div>
      
      <div className="aura-glow aura-1"></div>
      <div className="aura-glow aura-2"></div>
      
      <div className="container hero-container">
        <div className="funding-badge fade-in">
          <span className="funding-badge-text">22 years old & Ready to Build</span>
          <div className="funding-badge-border"></div>
        </div>
        <h1 className="hero-title fade-in delayed-1">
          Relentless <AnimatedText />
          <br />
          to <span className="highlight-box">Grow</span> Your Vision
        </h1>
        <p className="hero-subtitle fade-in delayed-2">
          I'm a fast-learning developer, Contrarian thinker and creative problem-solver. I dont claim to be an expert, but seek to grow pushing the limits of what's possible. I want to do hard shit, and be great at it.
        </p>
        
        <div className="hero-buttons fade-in delayed-3">
          <a href="#video-application" className="btn btn-primary">Video Application</a>
          <a href="mailto:aminsweiti@gmail.com" className="btn btn-outline">
            <span>Hire Me</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero; 